<template>
  <HeadingLv1
    class="heading"
    text="イベント・セミナー アーカイブ"
    disableMargin
  />

  <div class="topics" v-if="topics.length">
    <div class="u-containar ">
      <div class="title">おすすめトピックス</div>
      <div class="button-list">
        <button
          v-for="topic in topics"
          :key="topic.name"
          @click="selectTopic(topic.slug)"
          :class="{ selected: selectedTopic === topic.slug }"
        >
          {{ topic.name }}
        </button>
      </div>
    </div>
  </div>

  <div class="u-containar responsive">
    <div>
      <div class="inputFlex">
        <InputSelectbox
          :options="filterTypes"
          class="selector"
          @selection-change="selectFilterType"
          :value="selectedFilterType"
        />
        <InputSelectbox
          :options="categories"
          class="selector"
          @selection-change="selectCategory"
          :value="selectedCategory"
        />
      </div>
      <Loader v-if="loading" />
      <div v-else-if="archives.length">
        <div class="eventCards">
          <EventCardArchive v-for="e in archives" :key="e.id" :event="e" />
        </div>
        <Pagination class="pagination" :totalPages="totalPages" />
      </div>

      <Alert v-else text="現在公開中のアーカイブ動画はありません。" />
      <div class="buttonWrapper">
        <p>リアルタイムに病院と出会うチャンスも！</p>
        <Button
          label="開催中イベント一覧へ"
          primary
          class="buttonPrimary"
          href="/events/list"
          :handleClick="() => $router.push('/events/list')"
        />
      </div>
    </div>
    <div class="side">
      <div class="sideInner">
        <Button
          label="開催中イベント一覧へ"
          primary
          class="sideBtn"
          href="/events/list"
          :handleClick="() => $router.push('/events/list')"
        />
        <EventFooter />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import HeadingLv1 from '@/components/elements/HeadingLv1.vue'
import EventFooter from '@/components/block/EventFooter.vue'
import EventCardArchive from '@/components/block/EventCardArchive.vue'
import Alert from '@/components/elements/Alert.vue'
import InputSelectbox from '@/components/elements/InputSelectbox.vue'
import Loader from '@/components/elements/Loader.vue'
import Button from '@/components/elements/Button.vue'
import { useEvent } from '@/provider/event'
import { computed, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import Pagination from '@/components/block/Pagination.vue'
export default {
  name: 'EventsArchive',
  components: {
    HeadingLv1,
    EventFooter,
    InputSelectbox,
    Alert,
    EventCardArchive,
    Loader,
    Button,
    Pagination
  },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const {
      totalArchivePages: totalPages,
      loadArchives,
      archives: archivesBase,
      loadAllArchiveCategorys,

      loading,
      allArchiveCategories,
      allArchiveFilterTypes,
      allArchiveTopics
    } = useEvent()

    loadAllArchiveCategorys()

    const loadEventArchies = () => {
      loadArchives({
        per_page: 20,
        page: route.query.page ? Number(route.query.page) : undefined,
        category: route.query.category ? route.query.category : undefined,
        tag: route.query.tag ? route.query.tag : undefined,
        type: route.query.type ? route.query.type : undefined
      })
    }

    const topics = computed(() => allArchiveTopics.value)
    const categories = computed(() => allArchiveCategories.value)
    const filterTypes = computed(() => allArchiveFilterTypes.value)
    const selectedTopic = ref<any>(
      route.query.tag ? route.query.tag : undefined
    )
    const selectedCategory = ref<any>(
      route.query.category ? route.query.category : undefined
    )
    const selectedFilterType = ref<any>(
      route.query.type ? route.query.type : undefined
    )
    const selectTopic = (val: string) => {
      selectedTopic.value = val
      router.push({
        name: 'EventsArchivesList',
        query: { ...route.query, tag: val ? decodeURI(val) : '', page: 1 }
      })
    }
    const selectCategory = (val: string | null | undefined) => {
      selectedCategory.value = val
      router.push({
        name: 'EventsArchivesList',
        query: { ...route.query, category: val ? decodeURI(val) : '', page: 1 }
      })
    }
    const selectFilterType = (val: string | null | undefined) => {
      selectedFilterType.value = val
      router.push({
        name: 'EventsArchivesList',
        query: { ...route.query, type: val ? decodeURI(val) : '', page: 1 }
      })
    }

    const archives = computed(() => archivesBase.value)

    watch(
      () => [
        route.query.page,
        route.query.type,
        route.query.category,
        route.query.tag
      ],
      (next, prev) => {
        if (JSON.stringify(next) === JSON.stringify(prev)) return
        loadEventArchies()
      },
      { immediate: true }
    )

    return {
      loading,
      topics,
      categories,
      filterTypes,
      selectTopic,
      selectedTopic,
      selectCategory,
      selectedCategory,
      selectFilterType,
      selectedFilterType,
      archives,
      totalPages
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.responsive {
  display: grid;
  gap: 48px;
  @include mixins.media() {
    grid-template-columns: 1fr 242px;
    gap: 30px;
  }
  margin-top: 40px;
  margin-bottom: 30px;
}
::v-deep .heading {
  background-color: black;
}
.topics {
  background-color: var.$color-accent-back;
  padding: 32px 0;

  .selected {
    border: solid 0.5px var.$color-main-text !important;
  }
  .button-list {
    button {
      border: solid 0.5px var.$color-border-gray;
      background-color: var.$color-white;
      border-radius: 8px;
      padding: 15px 20px;
      line-height: 1rem;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
      margin-right: 8px;
      margin-bottom: 8px;
    }
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
  }
  .title {
    font-size: 18px;
    font-weight: 500;
    line-height: 1.8rem;
    margin-bottom: 12px;
  }
  margin-bottom: 24px;
  @include mixins.media() {
    margin-bottom: 40px;
  }
}
.inputFlex {
  display: flex;
  justify-content: flex-end;
  .selector {
    max-width: 140px;
    margin-left: 0;
    &:first-child {
      margin-right: 20px;
    }
  }
}
.selector {
  margin-bottom: 24px;
}
.eventCards {
  display: grid;
  gap: 24px 54px;
  grid-template-columns: repeat(auto-fill, calc(100%));
  @include mixins.media() {
    grid-template-columns: repeat(auto-fill, calc(50% - 27px));
    margin-top: 48px;
  }
}
.buttonWrapper {
  border-top: solid 0.5px var.$color-border-gray;
  margin-top: 64px;
  padding-top: 36px;
  p {
    text-align: center;
    font-size: 12px;
    line-height: 12px;
    margin-bottom: 8px;
  }
}
.side {
  @include mixins.media() {
    position: relative;
  }
}
.sideInner {
  @include mixins.media() {
    position: sticky;
    right: 0;
    top: 0;
  }
}
.sideBtn {
  display: none;
  @include mixins.media() {
    display: flex;
    margin-bottom: 24px;
  }
}
.pagination {
  width: 100%;
  max-width: 400px;
  margin: 50px auto;
}
</style>
